import $ from 'jquery';

$(function() {

  $('.js-material-select').on('dropdown-update', function(e){

    const key = e.detail;
    const selected = $('.pricing__grid')[key];

    $('.pricing__grid').slideUp(300, function() {
      $(selected).slideDown(300);
    });

  });

  $('.js-downloads-toggle').on('click', function() {
    $(this).toggleClass('active');
    $(this).siblings('.product-downloads__list').slideToggle();
    $(this).siblings('.product-downloads__list').toggleClass('active');
  });

});